// Ported from monorepo/src/components/corpus/recommendation-list.tsx.
import type { ReadingCandidate } from "@bindery/shared/corpus/selection";
import { ReadingCard } from "./reading-card";

interface RecommendationListProps {
  candidates: ReadingCandidate[];
  emptyMessage?: string;
}

/**
 * Sorted list of reading candidates (pre-sorted by challenge score
 * descending — phase 3's ordering is the contract, not the view's).
 */
export function RecommendationList({
  candidates,
  emptyMessage = "No recommendations found. Try adjusting your vocabulary profile.",
}: RecommendationListProps) {
  if (candidates.length === 0) {
    return (
      <div className="bg-muted/40 flex min-h-48 items-center justify-center rounded-lg border border-dashed">
        <p className="text-muted-foreground text-center text-sm">
          {emptyMessage}
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {candidates.map((candidate) => (
        <ReadingCard key={candidate.id} candidate={candidate} />
      ))}
    </div>
  );
}
